<template>
    <v-text-field v-model="formattedValue" v-bind="attrs" v-on="listeners()">
        <template v-for="(index, name) in $slots" v-slot:[name]>
            <slot :name="name" />
        </template>
    </v-text-field>
</template>

<script>
// https://phiny1.github.io/v-currency-field/started.html#direct-download-via-cdn
// https://github.com/phiny1/v-currency-field/blob/master/src/VCurrencyField.vue
import { formatAsCurrency} from "../utilities/utils";
export default {
    props: ["value"],
    data() {
        return {
            val: 0,
        }
    },
    computed: {
        attrs() {
            // eslint-disable-next-line
            const { value, ...attrs } = this.$attrs; // all but input event
            return attrs;
        },
        formattedValue: {
            get() {

                if(!this.val){
                    return;
                }

                return formatAsCurrency(this.val);
            },
            set(newValue){
                newValue = newValue.toString().replace(/\s/gm,"");
                if(isNaN(Number(newValue))){
                    return;
                }
                
                // remove decimal
                newValue = Math.floor(Number(newValue));

                this.val = newValue;
                this.$emit("input", this.val);
            }
        }
    },
    methods: {
        listeners() {
            // eslint-disable-next-line
            const { input, ...listeners } = this.$listeners; // all but input event
            return listeners;
        }
    },
    watch: {
        value: {
            handler: function(val) {
                // this.val = this.value;
                this.val = val;
            }
        }
    },
    mounted() {
        this.val = this.value;
    }
    
}
</script>